<template>
  <div class="">
    <div class="sm:mx-auto sm:w-full sm:max-w-screen-md">
      <h2 class="mt-6 text-center text-2xl font-extrabold text-brand-gray-900">
        Create Your Account
      </h2>
      <p class="mt-2 text-center text-sm text-brand-gray-600">
        Please complete the form below to finalize your registration and gain access to your Hurst Review course.
      </p>
      <div v-if="errors.length > 0" class="mt-4 bg-amber-50 border-l-4 border-amber-400 p-4">
        <div class="flex">
          <div class="flex-shrink-0">
            <!-- Heroicon name: solid/exclamation -->
            <svg class="h-5 w-5 text-amber-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                 fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd"
                    d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                    clip-rule="evenodd"/>
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm text-amber-700">
              {{ error }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-screen-sm">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <form class="mt-9 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8" action="#" method="POST"
              @submit.prevent="submit">
          <div>
            <div
                class="relative border border-brand-gray-300 rounded-md px-3 py-2 shadow-sm focus-within:ring-1 focus-within:ring-purple-600 focus-within:border-purple-600">
              <label for="firstName"
                     class="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-brand-gray-900">First
                Name</label>
              <input type="text" v-model="form.firstName" id="firstName"
                     class="block w-full border-0 p-0 text-brand-gray-900 placeholder-brand-gray-500 focus:ring-0 sm:text-sm"
                     placeholder="Hurst" required>
            </div>
            <p v-if="hasError('firstName')" class="mt-2 text-sm text-red-600">{{ errors['firstName'][0] }}</p>
          </div>
          <div>
            <div
                class="relative border border-brand-gray-300 rounded-md px-3 py-2 shadow-sm focus-within:ring-1 focus-within:ring-purple-600 focus-within:border-purple-600">
              <label for="lastName"
                     class="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-brand-gray-900">Last
                Name</label>
              <input type="text" v-model="form.lastName" id="lastName"
                     class="block w-full border-0 p-0 text-brand-gray-900 placeholder-brand-gray-500 focus:ring-0 sm:text-sm"
                     placeholder="Student" required>
            </div>
            <p v-if="hasError('lastName')" class="mt-2 text-sm text-red-600">{{ errors['lastName'][0] }}</p>
          </div>
          <div>
            <div
                class="relative border border-brand-gray-300 rounded-md px-3 py-2 shadow-sm focus-within:ring-1 focus-within:ring-purple-600 focus-within:border-purple-600">
              <label for="emailAddress"
                     class="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-brand-gray-900">Email
                Address</label>
              <input type="email" v-model="form.emailAddress" id="emailAddress"
                     class="block w-full border-0 p-0 text-brand-gray-900 placeholder-brand-gray-500 focus:ring-0 sm:text-sm"
                     placeholder="student@hurstreview.com" required>
            </div>
            <p v-if="hasError('emailAddress')" class="mt-2 text-sm text-red-600">{{ errors['emailAddress'][0] }}</p>
          </div>
          <div>
            <div
                class="relative border border-brand-gray-300 rounded-md px-3 py-2 shadow-sm focus-within:ring-1 focus-within:ring-purple-600 focus-within:border-purple-600">
              <label for="mobilePhone"
                     class="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-brand-gray-900">Mobile
                Phone</label>
              <input type="tel" v-model="form.mobilePhone" id="mobilePhone"
                     class="block w-full border-0 p-0 text-brand-gray-900 placeholder-brand-gray-500 focus:ring-0 sm:text-sm"
                     placeholder="555-867-5309" required>
            </div>
            <p v-if="hasError('mobilePhone')" class="mt-2 text-sm text-red-600">{{ errors['mobilePhone'][0] }}</p>
          </div>
          <div>
            <div
                class="relative border border-brand-gray-300 rounded-md px-3 py-2 shadow-sm focus-within:ring-1 focus-within:ring-purple-600 focus-within:border-purple-600">
              <label for="password"
                     class="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-brand-gray-900">Create
                Password</label>
              <input type="password" v-model="form.password" id="password"
                     class="block w-full border-0 p-0 text-brand-gray-900 placeholder-brand-gray-500 focus:ring-0 sm:text-sm"
                     required>
            </div>
            <p v-if="hasError('password')" class="mt-2 text-sm text-red-600">{{ errors['password'][0] }}</p>
          </div>
          <div>
            <div
                class="relative border border-brand-gray-300 rounded-md px-3 py-2 shadow-sm focus-within:ring-1 focus-within:ring-purple-600 focus-within:border-purple-600">
              <label for="confirm_password"
                     class="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-brand-gray-900">Confirm
                Password</label>
              <input type="password" v-model="form.confirm_password" id="confirm_password"
                     class="block w-full border-0 p-0 text-brand-gray-900 placeholder-brand-gray-500 focus:ring-0 sm:text-sm"
                     required>
            </div>
            <p v-if="hasError('confirm_password')" class="mt-2 text-sm text-red-600">
              {{ errors['confirm_password'][0] }}</p>
          </div>
          <div>
            <fieldset class="relative border border-brand-gray-300 rounded-md px-3 py-2 shadow-sm grid grid-cols-5">
              <legend
                  class="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-brand-gray-900">
                <span v-if="account !== null && account.relationshipType === 'Hospital'">Hire Date</span>
                <span v-else>Expected Graduation</span>
              </legend>
              <label for="grad_month" class="sr-only"><span
                  v-if="account !== null && account.relationshipType === 'Hospital'">Hire</span><span
                  v-else>Graduation</span> Month</label>
              <input type="number" v-model.number="form.graduationMonth" id="grad_month"
                     class="col-span-2 block w-full border-0 p-0 text-brand-gray-900 placeholder-brand-gray-500 focus:ring-0 sm:text-sm"
                     min="01" max="12" placeholder="MM" required>
              <div class="text-center">/</div>
              <label for="grad_year" class="sr-only"><span
                  v-if="account !== null && account.relationshipType === 'Hospital'">Hire</span><span
                  v-else>Graduation</span> Year</label>
              <input type="number" v-model.number="form.graduationYear" id="grad_year"
                     class="col-span-2 block w-full border-0 p-0 text-brand-gray-900 placeholder-brand-gray-500 focus:ring-0 sm:text-sm"
                     min="2021" max="2030" placeholder="YYYY" required>
            </fieldset>
            <p v-if="hasError('graduationMonth')" class="mt-2 text-sm text-red-600">
              {{ errors['graduationMonth'][0] }}</p>
            <p v-if="hasError('graduationYear')" class="mt-2 text-sm text-red-600">{{ errors['graduationYear'][0] }}</p>
          </div>
          <div>
            <div
                class="relative border border-brand-gray-300 rounded-md py-2 shadow-sm focus-within:ring-1 focus-within:ring-purple-600 focus-within:border-purple-600">
              <label for="degreeType"
                     class="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-brand-gray-900">Degree</label>
              <select v-model="form.degreeType" id="degreeType"
                      class="block w-full border-0 p-0 pl-3 text-brand-gray-900 placeholder-brand-gray-500 focus:ring-0 sm:text-sm"
                      required>
                <option :value="null">-- Select Your Degree Type --</option>
                <option value="BSN">BSN</option>
                <option value="ADN">ADN</option>
                <option value="PN">LPN</option>
              </select>
            </div>
            <p v-if="hasError('degreeType')" class="mt-2 text-sm text-red-600">{{ errors['degreeType'][0] }}</p>
          </div>
          <div v-if="children.length > 0">
            <div
                class="relative border border-brand-gray-300 rounded-md py-2 shadow-sm focus-within:ring-1 focus-within:ring-purple-600 focus-within:border-purple-600">
              <label for="nursingSchoolId"
                     class="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-brand-gray-900">
                <span v-if="account !== null && account.relationshipType === 'Hospital'">Hospital/Employer</span><span
                  v-else>Nursing School</span>
              </label>
              <select v-model="form.schoolId" id="nursingSchoolId"
                      class="block w-full border-0 p-0 pl-3 text-brand-gray-900 placeholder-brand-gray-500 focus:ring-0 sm:text-sm"
                      required>
                <option :value="null">-- Select An Option --</option>
                <option v-for="child in children" :value="child.schoolId">{{ child.schoolName }}</option>
              </select>
            </div>
            <p v-if="hasError('degreeType')" class="mt-2 text-sm text-red-600">{{ errors['degreeType'][0] }}</p>
          </div>

          <div class="sm:col-span-2 flex justify-center">
            <button type="submit"
                    :disabled="submitting"
                    class="w-full sm:w-1/2 flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 disabled:bg-purple-300 disabled:cursor-wait">
                            <span class="flex" v-if="submitting">
                                <svg class="animate-spin h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none"
                                     viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                        stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor"
                                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg> Saving
                            </span>
              <span v-else>Register</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CreateAccount',
  props: {
    createOnly: {type: Boolean, required: false, default: false},
    email: {type: String, required: false, default: null},
    registrationCode: {type: Object, required: true},
    account: {type: Object, required: false, default: null},
    children: {type: Array, required: false, default: () => []},
    withShipping: {type: Boolean, default: false},
  },
  data() {
    return {
      autocomplete: null,
      errors: {},
      form: {
        createOnly: this.createOnly,
        confirm_password: null,
        degreeType: null,
        emailAddress: this.email,
        firstName: null,
        graduationMonth: null,
        graduationYear: null,
        lastName: null,
        mobilePhone: null,
        schoolId: this.children.length === 0 ? this.registrationCode.orgCode.account.schoolId : null,
        password: null,
        registrationCode: this.registrationCode.registration_code,
        shippingAddress: {
          address1: null,
          address2: null,
          city: null,
          state: null,
          street_number: null,
          route: null,
          locality: null,
          administrative_area_level_1: null,
          country: null,
          postal_code: null,
          postal_code_suffix: null
        }
      },
      locationClient: null,
      shippingAddress: null,
      submitting: false,
    };
  },
  mounted() {
    // let mapsScript = document.createElement('script');
    // mapsScript.setAttribute('src',
    //     'https://maps.googleapis.com/maps/api/js?key=AIzaSyDVx_WowNgwEq6yOXVVjp7Xt71iqUwcT_8&libraries=places&callback=initAutocomplete');
    // mapsScript.async = true;
    // document.head.appendChild(mapsScript);

    // window.initAutocomplete = () => {
    //   this.autocomplete = new google.maps.places.Autocomplete(document.getElementById('shipping'),
    //       {types: ['geocode']});
    //   this.autocomplete.addListener('place_changed', this.addressSelected);
    // };
  },

  methods: {
    // async addressSelected() {
    //   let place = this.autocomplete.getPlace();
    //   console.log(place);
    //   this.latitude = place.geometry.location.lat();
    //   this.longitude = place.geometry.location.lng();
    //   place.address_components.forEach((item) => {
    //     this.form.shippingAddress[item.types[0]] = item.short_name;
    //   });
    //   this.form.shippingAddress.address1 = `${this.form.shippingAddress.street_number} ${this.form.shippingAddress.route}`;
    //   this.form.shippingAddress.postal_code = `${this.form.shippingAddress.postal_code}-${this.form.shippingAddress.postal_code_suffix}`;
    //   this.form.shippingAddress.city = this.form.shippingAddress.locality;
    //   this.form.shippingAddress.state = this.form.shippingAddress.administrative_area_level_1;
    //   this.shippingAddress = this.form.shippingAddress.address1;
    // },

    hasError(field) {
      return this.errors.hasOwnProperty(field);
    },

    async submit() {
      this.submitting = true;
      this.errors = {};
      try {
        const {data} = await axios.post('/api/bookstore/create-account', this.form);
        this.$emit('account-created', data);
      } catch ({response}) {
        this.errors = response.data;
      }
      this.submitting = false;
    },
  },
};
</script>

<style scoped>

</style>